module.exports = __webpack_public_path__ + "img/37fc57d42dbf2a8454690b6cf09356c6.37fc57d4.png";